import { defineStore } from 'pinia'

import { apiClient } from "@/helpers/api.js"
import { handleApiError } from '@/services/errorHandler'
import { useBatchStore } from '@/stores/BatchStore'

export const useSearchStore = defineStore('SearchStore', {
  state: () => {
    return {
      comboboxDialog: false,
      selectedFilter: '',
      recentSearches: [ 'Mike Trout', 'Mike Trou', 'Mike Tro', 'Mike Tr', 'Mike T', 'Mike', 'Mik', 'Mi', 'M' ],
      searchState: 'start',

      batchesSearched: [],
      recentlyModifiedBatches: [],
      cdp_search: {
        open: false,
        state: '',
        locationOfSearchCall: ''
      },

      loadingBatches: false,
      loadingMatches: false,
      loadingMoreMatches: false,

      hoveredOverMatchCard: null,

      matchesData: {
        matches: []
      },

      // Shared seed so every DatabaseMatchField instance for the selected card
      // (regular + pinned copy) stays in sync when a match is removed: they all
      // pre-fill the search input with the removed match title. Keyed by cardId
      // so a stale seed from another card can't leak in.
      databaseMatchSeed: { cardId: null, term: '' },

      triggerOpenSearchResult: false
    }
  },

  actions: {
    updateSearchStateBasedOnDataObject(data) {
      Object.entries(data).forEach(([key, value]) => {
        if (typeof value === 'object') {
          Object.entries(data).forEach(([key, value]) => {
            this[key] = value
          })
        } else {
          this[key] = value
        }
      })
    },
    async searchUserBatches(options = {}) {
      try {
        const { query, kind } = options

        this.loadingBatches = true

        const params = {}

        if (query) {
          params.q = query
        }

        if (kind) {
          params.kind = kind
        }

        const { data } = await apiClient().get(`/batches`, query || kind ? {
          params
        } : {})

        if (!query) {
          this.recentlyModifiedBatches = data.items.sort((a, b) => {
            const dateA = new Date(a.updated_at)
            const dateB = new Date(b.updated_at)
            return dateB - dateA; // Sorting in descending order
          }).slice(0, 5)
        } else {
          this.recentlyModifiedBatches = []
        }
        this.batchesSearched = data.items
        this.loadingBatches = false
      } catch (error) {
        handleApiError(error, { component: 'SearchStore', action: 'searchUserBatches' })
        this.loadingBatches = false
      }
    },

    async searchDatabaseMatches(options = {}, skipLoaderUpdate = false) {
      const { query, page = 1, kind } = options
      const batchStore = useBatchStore() 
      try {
        if (!query && this.selectedFilter === 'Card Database' && batchStore.selectedBatchDetailsViewOption === 'Inspector') {
          this.matchesData = {
            matches: []
          }
          return 
        }

        this.loadingMoreMatches = true

        if (!skipLoaderUpdate) {
          this.loadingMatches = true
        }
       
        const params = {
          page
        }

        if (query) {
          params.q = query
        }

        if (kind) {
          params.kind = kind
        }

        if (options.baseSetIds) {
          params.baseSetIds = options.baseSetIds
        }

        if (options.setIds) {
          params.setIds = options.setIds
        }

        const { data } = await apiClient(true).get(`/search`, query || kind ? {
          params
        } : {})

        if (page > 1) {
          this.matchesData = { ...data, matches: [...this.matchesData.matches, ...data.matches] }
        } else {
          this.matchesData = { ...data, matches: data.matches ? [...data.matches] : [] }
        }

        this.loadingMatches = false
        this.loadingMoreMatches = false
      } catch (error) {
        this.loadingMatches = false
        this.loadingMoreMatches = false
        handleApiError(error, { component: 'SearchStore', action: 'searchDatabaseMatches' })
      }
    },

  }
})